import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PasswordChange } from '../../models/password-change.dto';
import { AuthenticationService } from '../../services/authentication.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nap-reset-password',
  templateUrl: './nap-reset-password.component.html',
  styleUrls: ['./nap-reset-password.component.scss']
})
export class NapResetPasswordComponent implements OnInit {

  validateForm!: FormGroup;
  isEditMode!: boolean;
  passwordVisible = false;
  agencyUserId!: string;
  pwChange!: PasswordChange;

  constructor(
    private authenticationService: AuthenticationService,
    private notification: NzNotificationService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router
  ) {
    this.agencyUserId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      newPassword: [null, Validators.required],
      confirmPassword: ['', [Validators.minLength(8), this.confirmValidator]],
    });
  }

  submitForm() {
    for (const key of Object.keys(this.validateForm.controls)) {
      this.validateForm.controls[key].markAsDirty();
      this.validateForm.controls[key].updateValueAndValidity();
    }
    this.pwChange = this.validateForm.value;
    this.authenticationService.resetNapPassword(this.pwChange.newPassword, this.agencyUserId)
      .subscribe((response) => {
        if (response.statusCodeValue == 200) {
          this.resetForm();
          this.notification.success('Success!', response.body);
          this.router.navigateByUrl('/NAP-login');
        } else {
          this.notification.error('Failed', response.body);
        }
      });
  }

  resetForm(): void {
    this.validateForm.reset();
    this.isEditMode = false;
    for (const key of Object.keys(this.validateForm.controls)) {
      this.validateForm.controls[key].markAsPristine();
      this.validateForm.controls[key].updateValueAndValidity();
    }
  }

  validateConfirmPassword(): void {
    setTimeout(() =>
      this.validateForm.controls.confirmPassword.updateValueAndValidity()
    );
  }

  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (
      control.value !== this.validateForm.controls.newPassword.value
    ) {
      return { confirm: true, error: true };
    }
    return {};
  };
}
